module.exports = __webpack_public_path__ + "img/09 Automaterijal.44850840.png";